type TMembership = { id: string; slug: string };

export const getHomeOrganizationSlug = (
  currentOrganizationId: string | undefined,
  memberships: readonly TMembership[] | undefined,
): string | undefined => {
  const currentMembership = memberships?.find((membership) => membership.id === currentOrganizationId);
  return (currentMembership ?? memberships?.[0])?.slug;
};
